"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIForm = _interopRequireDefault(require("UIComponents/form/UIForm"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UITextArea = _interopRequireDefault(require("UIComponents/input/UITextArea"));

var _BaseReviewModal = _interopRequireDefault(require("./BaseReviewModal"));

var _ReportReasons = require("../../../constants/reviews/ReportReasons");

var textPath = 'ecosystemMarketplaceCore.reviews.modal.report';

var ReportReviewModal = function ReportReviewModal(props) {
  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      reason = _useState2[0],
      setReason = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      comment = _useState4[0],
      setComment = _useState4[1];

  var reasonOptions = (0, _react.useMemo)(function () {
    var reasons = props.type === _ReportReasons.Reportables.REVIEW ? _ReportReasons.ReportReviewReasons : _ReportReasons.ReportReplyReasons;
    return Object.values(reasons).map(function (opt) {
      return {
        text: (0, _unescapedText.default)("ecosystemMarketplaceCore.reviews.reportReasons." + props.type + "." + opt + ".description"),
        value: opt
      };
    });
  }, [props.type]);
  var form = (0, _react.useMemo)(function () {
    return _react.default.createElement(_UIForm.default, null, _react.default.createElement(_UIFormControl.default, {
      required: true,
      label: _react.default.createElement(_FormattedMessage.default, {
        message: textPath + ".reason"
      })
    }, _react.default.createElement(_UISelect.default, {
      onChange: function onChange(_ref) {
        var value = _ref.target.value;
        return setReason(value);
      },
      options: reasonOptions,
      value: reason,
      placeholder: _react.default.createElement(_FormattedMessage.default, {
        message: textPath + ".reasonPlaceholder"
      })
    })), _react.default.createElement(_UIFormControl.default, {
      required: true,
      label: _react.default.createElement(_FormattedMessage.default, {
        message: textPath + ".comment"
      })
    }, _react.default.createElement(_UITextArea.default, {
      placeholder: (0, _unescapedText.default)(textPath + ".commentPlaceholder"),
      value: comment,
      onChange: function onChange(_ref2) {
        var value = _ref2.target.value;
        return setComment(value);
      },
      rows: 6
    })));
  }, [comment, reason, reasonOptions]);
  return _react.default.createElement(_BaseReviewModal.default, (0, _extends2.default)({}, props, {
    form: form,
    confirmDisabled: !reason || !comment,
    onConfirm: function onConfirm() {
      return props.onConfirm(reason, comment);
    },
    tooltip: _react.default.createElement(_FormattedMessage.default, {
      message: textPath + ".tooltip"
    })
  }));
};

var _BaseReviewModal$prop = _BaseReviewModal.default.propTypes,
    __form = _BaseReviewModal$prop.form,
    baseProps = (0, _objectWithoutProperties2.default)(_BaseReviewModal$prop, ["form"]);
ReportReviewModal.propTypes = (0, _extends2.default)({}, baseProps, {
  type: _propTypes.default.oneOf(Object.keys(_ReportReasons.Reportables))
});
ReportReviewModal.defaultProps = {
  title: _react.default.createElement(_FormattedMessage.default, {
    message: textPath + ".title"
  }),
  type: _ReportReasons.Reportables.REVIEW
};
var _default = ReportReviewModal;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/reviews/modals/ReportReviewModal.js
// module id = 872
// module chunks = 209 210 211 212